'use client';

import { createStore } from 'zustand';

import { SchedulesSearchSlot } from '@/app/(main)/(pages)/_components/schedules/_types/schedule-slot.type';
import { CartItem } from '@/types/cart.types';

export interface ScheduleSelectionRequest {
  items: CartItem[];
  onSelectSlot?: (slot: SchedulesSearchSlot) => void;
}

export type ScheduleSelectionState = {
  isOpen: boolean;
  request: ScheduleSelectionRequest | null;
};

const initialState: ScheduleSelectionState = {
  isOpen: false,
  request: null,
};

export const scheduleSelectionStore = createStore<ScheduleSelectionState>(() => ({ ...initialState }));

export const openScheduleSelection = (request: ScheduleSelectionRequest) => {
  scheduleSelectionStore.setState({ isOpen: true, request });
};

export const closeScheduleSelection = () => {
  scheduleSelectionStore.setState({ ...initialState });
};

export const selectScheduleSlot = (slot: SchedulesSearchSlot) => {
  const { request } = scheduleSelectionStore.getState();

  closeScheduleSelection();
  request?.onSelectSlot?.(slot);
};
